import React from 'react'

export default class Breadcrumbs extends React.Component
  link: (parent, index) =>
    <li key={index}>
      <a href="" onClick={(event) => event.preventDefault(); @props.onClick(index)}>{parent}</a>
    </li>

  render: ->
    <ol className="breadcrumb">
      {@props.parents.map(@link)}
      <li className="active">{@props.current}</li>
    </ol>
